import { auth, googleProvider } from "@/firebase";
import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";

export default {
    namespaced: true,

    state: {},
    mutations: {},
    
    actions: {
        async loginWithEmail(context, payload) {
            const {email, password, router} = payload
            
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            const userData = {
                id: user.uid,
                email: user.email,
                password: password
            };

            localStorage.setItem('user', JSON.stringify(userData))

            context.dispatch('checkLoggedIn', null, {root: true});

            router.push(`/Profile/${user.uid}`);
        },

        async loginWithGoogle(context, router) {
            const userCredential = await signInWithPopup(auth, googleProvider);
            const user = userCredential.user;
            
            const userData = {
                id: user.uid,
                email: user.email,
                displayName: user.displayName || "Google User",
            };

            localStorage.setItem('user', JSON.stringify(userData))

            context.dispatch('checkLoggedIn', null, {root: true});

            router.push(`/Profile/${user.uid}`);

        }
    },
    getters: {}
}